export const UNALLOCATED_GROUP_PREFIX = "Unallocated-";
export const TIMELINE_GROUP_SHOW_ALL = "timelineGroup_SHOWALL";

const getUnallocatedGroupIdForType = typeId => `${UNALLOCATED_GROUP_PREFIX}${typeId}`;

export default {
  getUnallocatedGroupIdForType
};
